import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, Timestamp, Unsubscribe } from 'firebase/firestore';
import { db } from '../firebase';

interface WaitingApplication {
  id: string;
  createdAt: Date;
  uid: string;
  status: 'pending' | 'approved' | 'rejected' | 'checked' | 'consumed';
}

export const useWaitingApplications = () => {
  const [waitingList, setWaitingList] = useState<WaitingApplication[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let unsubscribe: Unsubscribe | null = null;

    try {
      const q = query(
        collection(db, 'portville_applications'),
        orderBy('createdAt', 'asc')
      );

      // Firestore 실시간 리스너 설정
      unsubscribe = onSnapshot(
        q,
        (querySnapshot) => {
          const applications = querySnapshot.docs.map((doc) => {
            const data = doc.data();
            let createdAt: Date;

            try {
              if (data.createdAt instanceof Timestamp) {
                createdAt = data.createdAt.toDate();
              } else if (data.createdAt && typeof data.createdAt.toDate === 'function') {
                createdAt = data.createdAt.toDate();
              } else if (data.createdAt && typeof data.createdAt === 'string') {
                createdAt = new Date(data.createdAt);
              } else if (data.createdAt && typeof data.createdAt === 'number') {
                createdAt = new Date(data.createdAt);
              } else {
                createdAt = new Date();
              }
            } catch (err) {
              createdAt = new Date();
            }

            return {
              id: doc.id,
              uid: data.uid || '',
              createdAt,
              status: data.status || 'pending'
            };
          });

          setWaitingList(applications);
          setLoading(false);
          setError(null);
        },
        (err) => {
          console.error('대기 목록 실시간 업데이트 오류:', err);
          setError('대기 목록을 불러오는데 실패했습니다. 잠시 후 다시 시도해주세요.');
          setLoading(false);
          setWaitingList([]);
        }
      );
    } catch (err) {
      console.error('대기 목록 쿼리 생성 오류:', err);
      setError('대기 목록을 불러오는데 실패했습니다. 잠시 후 다시 시도해주세요.');
      setLoading(false);
      setWaitingList([]);
    }

    // 컴포넌트 언마운트 시 리스너 해제
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return { waitingList, loading, error };
}; 
